'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChannelForBlockId = getChannelForBlockId;

var _pubNubHelpers = require('conversations-core/utils/pubNubHelpers');

var _userSelectors = require('conversations-core/selectors/userSelectors');

function getChannelForBlockId(state, blockId) {
  var blockedVistitors = state.blockedVisitors;
  var blockedVisitorForId = blockedVistitors.find(function (blockedVisitor) {
    return blockedVisitor.id === blockId;
  });

  if (!blockedVisitorForId) {
    return null;
  }

  var userId = (0, _userSelectors.getUserId)(state);
  var messagesUtk = blockedVisitorForId.messagesUtk,
      vid = blockedVisitorForId.vid;

  var channel = (0, _pubNubHelpers.buildChannelFromUtkOrVid)(userId, { messagesUtk: messagesUtk, vid: vid });

  return channel;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/utils/blockVisitorUtils.js
// module id = 524
// module chunks = 0